import type { ConceptDef } from '../types';

export const imitateMultiStep: ConceptDef = {
  kind: 'supervisorScored',
  id: 'imitate-multi-step',
  label: 'Imitate Multi-Step',
  category: 'Motor imitation',
  description: 'Model a multi-step action; learner imitates. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'Clap, then stand up.' },
      { prompt: 'Touch your nose, then your ear.' },
      { prompt: 'Stand, turn around, sit down.' },
      { prompt: 'Jump twice, then wave.' },
    ],
  },
};
